<template>
  <div
    @click="$router.push({ name: 'cp-reports' }).catch(() => {})"
    class="flex py-2 px-4 cursor-pointer"
    style="position: absolute; bottom: 5px; left: 5px"
    v-if="hasListManagement"
  >
    <feather-icon icon="SettingsIcon" svgClasses="w-4 h-4" />
    <span class="semi-bold">Manage lists</span>
  </div>
</template>

<script>
export default {
  computed: {
    hasListManagement() {
      return this.$store.getters["currentMenuHasListManagement"];
    },
  },
};
</script>
